import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * El catálogo de productos e insumos. La tarjeta es de la tarea 20 y la ruta la agrega la tarea 24 de la
 * fase 8.
 *
 * EN `_direccion` Y NUNCA AL ALCANCE DEL OPERARIO. El saldo sale de `rep.v_saldo_inventario`, que es
 * `security_invoker` sobre un libro de nivel 2: al operario le contesta cero en todo, y un inventario
 * entero en cero es la respuesta falsa que parece cierta de la adjudicación 210.
 */
export const rutaCatalogo = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/catalogo',
  component: lazyRouteComponent(() => import('./catalogo-pantalla.js'), 'RutaCatalogo'),
});
